import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { sequences } from 'app/pwa/app.cerebral';

import { Modal } from './elements';
import ActivityModalContent from './ActivityModalContent';

const deps = {
  closeActivityModalClicked: sequences`challenge.activityModal.closeActivityModalClicked`,
};

export function ActivityModal({
  closeActivityModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  return (
    <Modal onHide={() => closeActivityModalClicked()} show>
      <ActivityModalContent />
    </Modal>
  );
}

export default connect(deps, ActivityModal);
